import { useEffect, useState } from "react";
import { fetchNews } from "@/lib/api";
import { sanitize } from "@/lib/sanitize";
import AdSlot from "@/components/AdSlot";
import { Link } from "react-router-dom";
import { Newspaper, ExternalLink } from "lucide-react";

export default function News() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { fetchNews().then(r => { setItems(r); setLoading(false); }); }, []);
  const featured = items[0];
  const rest = items.slice(1);

  return (
    <div className="pt-16" data-testid="news-page">
      <div className="max-w-[1600px] mx-auto px-4 md:px-8 py-10">
        <p className="text-[#D4AF37] text-[11px] font-semibold tracking-[0.25em] uppercase mb-2 flex items-center gap-2"><Newspaper className="w-3 h-3"/>Christian News</p>
        <h1 className="font-heading text-4xl md:text-6xl font-bold mb-8 leading-none">The Living Report</h1>

        <AdSlot slot="news_banner" className="w-full h-24 mb-8" />

        {loading ? <p className="text-white/50">Loading…</p> : items.length === 0 ? (
          <p className="text-white/60" data-testid="news-empty">No news yet. Admins can refresh RSS in the admin panel.</p>
        ) : (
          <>
            {featured && (
              <Link to={`/news/${featured.id}`} className="grid md:grid-cols-[2fr_1fr] gap-6 mb-10 group" data-testid={`news-featured-${featured.id}`}>
                {featured.image_url && <div className="aspect-video md:aspect-auto rounded-2xl overflow-hidden bg-[#121216]"><img src={featured.image_url} alt="" className="w-full h-full object-cover group-hover:scale-105" style={{transition:"transform 0.5s"}} /></div>}
                <div className={!featured.image_url ? "md:col-span-2" : ""}>
                  <p className="text-[#D4AF37] text-[11px] font-semibold tracking-[0.25em] uppercase mb-2">{featured.source}</p>
                  <h2 className="font-heading text-3xl md:text-4xl font-bold leading-tight mb-3 group-hover:text-[#D4AF37]" style={{transition:"color 0.3s"}}>{featured.title}</h2>
                  <p className="text-white/70 line-clamp-3" dangerouslySetInnerHTML={{__html: sanitize((featured.body||"").replace(/<[^>]*>/g,'').slice(0,300) + '…')}} />
                  <p className="text-xs text-white/40 mt-4">{new Date(featured.published_at).toLocaleDateString([], {year:'numeric',month:'long',day:'numeric'})}</p>
                </div>
              </Link>
            )}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {rest.map(n => (
                <Link to={`/news/${n.id}`} key={n.id} className="bg-[#0A0A0E] border border-white/10 rounded-xl overflow-hidden group hover:border-white/25" style={{transition:"border-color 0.3s"}} data-testid={`news-card-${n.id}`}>
                  {n.image_url && <div className="aspect-video overflow-hidden bg-black"><img src={n.image_url} alt="" className="w-full h-full object-cover group-hover:scale-105" style={{transition:"transform 0.5s"}} onError={(e)=>e.target.style.display='none'} /></div>}
                  <div className="p-5">
                    <p className="text-[10px] text-[#D4AF37] tracking-widest uppercase mb-2">{n.source}</p>
                    <h3 className="font-heading text-lg font-semibold leading-tight line-clamp-2 mb-2 group-hover:text-[#D4AF37]" style={{transition:"color 0.3s"}}>{n.title}</h3>
                    <p className="text-xs text-white/40">{new Date(n.published_at).toLocaleDateString()}</p>
                  </div>
                </Link>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
